import { IGetState, TBoardId, TCardId } from 'app/types/types';
import { Dispatch, ThunkAction } from 'app/types/actions';
import { uploadFiles } from '../effects/uploadFiles';
import { SegmentCardEvent, SegmentCardPasteFileTarget } from 'app/middlewares/segment/trackEntities/cardEvents';
import { ERestDriveDocType } from 'app/types/rest/IRestDriveDoc';
import { IDriveDoc } from 'app/store/model/card/types/IDriveDoc';
import { segmentTrackAction } from 'app/middlewares/segment';
import {
    attachmentPastedSegmentEvent,
    attachmentPasteErrorSegmentEvent
} from '../../../CardAttachmentsSectionHOC/effects/segmentEffects';
import { commentUpdate } from '../../../../../../../base/components/Comments/store/reducers/actions/commentUpdate';

export const onPasteFileAsComment = (
    cardId: TCardId,
    files: File[],
    onProgress: (percent: number) => void
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (!files) {
            return dispatch(attachmentPasteErrorSegmentEvent(SegmentCardPasteFileTarget.COMMENT));
        }

        dispatch(attachmentPastedSegmentEvent(SegmentCardPasteFileTarget.COMMENT));
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_ATTACHMENT_PASTE));
        return dispatch(uploadFiles(cardId, files, onProgress, true, ERestDriveDocType.COMMENT))
            .then((driveDocs: IDriveDoc[]) => {
                dispatch(commentUpdate({ droppedAttachmentIds: driveDocs.map(driveDoc => driveDoc.id) }));
            });
    };
    return action;
};
